import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GuideHero = ({ onStartQuiz, onViewGuides }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/90 to-secondary overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full text-white text-sm font-medium mb-6">
              <Icon name="Award" size={16} className="mr-2" />
              Expert-Curated Buying Guides
            </div>
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Find Your Perfect
              <span className="block text-accent">Vacuum Cleaner</span>
            </h1>
            <p className="text-xl text-white/90 mb-8 max-w-2xl">
              Navigate through our comprehensive buying guides tailored to your home size, flooring type, lifestyle needs, and budget. Make informed decisions with expert insights and real-world testing data.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="default"
                size="lg"
                iconName="Zap"
                iconPosition="left"
                onClick={onStartQuiz}
                className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold"
              >
                Start Smart Quiz
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="BookOpen"
                iconPosition="left"
                onClick={onViewGuides}
                className="border-white/30 text-white hover:bg-white/10"
              >
                Browse All Guides
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <Icon name="Home" size={32} className="text-accent mb-3" />
                  <h3 className="text-white font-semibold mb-2">Home Size</h3>
                  <p className="text-white/80 text-sm">Apartments to mansions</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <Icon name="Heart" size={32} className="text-accent mb-3" />
                  <h3 className="text-white font-semibold mb-2">Pet Owners</h3>
                  <p className="text-white/80 text-sm">Specialized pet hair removal</p>
                </div>
              </div>
              <div className="space-y-4 mt-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <Icon name="Layers" size={32} className="text-accent mb-3" />
                  <h3 className="text-white font-semibold mb-2">Floor Types</h3>
                  <p className="text-white/80 text-sm">Carpet, hardwood, tile</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <Icon name="DollarSign" size={32} className="text-accent mb-3" />
                  <h3 className="text-white font-semibold mb-2">Budget Range</h3>
                  <p className="text-white/80 text-sm">$50 to $1000+</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideHero;